export default "__VITE_ASSET__Dl6tH_x8__"